/* eslint-disable stylistic/comma-dangle */

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
  baseStyle: {
    container: {
      minWidth: 'xs',
      width: 'full',
      boxShadow: 'base',
      backgroundColor: 'background.primary',
    },
    content: {
      maxWidth: '1440px',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingX: {base: '20px', lg: '80px'},
      paddingTop: {base: '20px', lg: '40px'},
      paddingBottom: {base: '20px', lg: '10px'},
      display: 'flex',
      flexDirection: 'column',
      rowGap: {base: 0, lg: '26px'},
    },
    searchContainer: {
      order: [2, 2, 2, 'inherit'],
      width: ['full', 'full', 'full', 60],
      marginRight: [0, 0, 0, 4],
      marginBottom: [1, 1, 2, 0],
    },
    bodyContainer: {
      flex: '1',
    },
    logo: {
      width: '100%',
      height: 'auto',
    },
    iconLogo: {
      display: 'flex',
      maxWidth: {base: '76px', lg: '112px'},
      maxHeight: {base: '17px', lg: '24px'},
    },
    icons: {
      display: 'flex',
      width: '20px',
      height: '20px',
      minWidth: 'auto',
      sx: {
        svg: {
          maxWidth: '100%',
          maxHeight: '100%',
        }
      }
    },
    buttonLocationIcon: {
      display: 'flex',
      justifyContent: 'center',
      height: 'auto',
      minWidth: 'auto',
      paddingX: {base: 0, md: 0, lg: 0},
    },
    buttonLocationText: {
      color: 'primary.darkLinen',
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '120%',
      textDecoration: 'underline',
      textDecorationThickness: '1.4px',
      textUnderlineOffset: '2.8px',
      whiteSpace: 'nowrap',
    },
    iconHamburger: {
      display: {base: 'flex', lg: 'none'},
    },
    actionsContainer: {
      display: 'flex',
      alignItems: 'center',
      columnGap: '32px',
      sx: {
        '> *:empty': {
          display: 'none',
        },
      }
    },
    accountIconDesktop: {
      display: {base: 'none', lg: 'inline'},
      height: '20px',
      minWidth: 'auto',
      cursor: 'pointer',
      alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
      _focus: {
        boxShadow: 'outline',
      },
      _focusVisible: {
        outline: 0,
      },
    },
    arrowDown: {
      height: '20px',
      minWidth: 'auto',
      marginRight: 0,
      alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
      cursor: 'pointer',
      _focus: {
        boxShadow: 'outline',
      },
      _focusVisible: {
        outline: 0,
      },
      display: ['none', 'none', 'none', 'block'],
    },
    wishlistIconDesktop: {
      display: {base: 'none', lg: 'flex'},
    },
    signout: {
      width: '100%',
      borderRadius: '4px',
      height: 11,
      padding: 4,
      py: 3,
      marginTop: 1,
      _hover: {
        background: 'gray.50',
      },
    },
    signoutText: {
      fontSize: 'sm',
      fontWeight: 'normal',
    },
    signoutIcon: {
      marginRight: 2,
    },
    languageIconDesktop: {
      display: {base: 'none', lg: 'inline-flex'},
      sx: {
        '.chakra-icon': {
          width: '24px',
          height: '24px',
        }
      }
    },
  },
  parts: ['container',
    'content',
    'actionsContainer',
    'searchContainer',
    'bodyContainer',
    'logo',
    'icons',
    'signout',
    'languageIconDesktop',
    'wishlistIconDesktop',
    'iconHamburger',
    'buttonLocationIcon',
    'buttonLocationText'],
};
